export enum IndustrialSprinkler {
  DRY = 'DRY',
  WET = 'WET',
  ESFR = 'ESFR',
  YES = 'YES',
  NONE = 'NONE',
}
